import { render } from "./in-hub.vue?vue&type=template&id=06feba76&ts=true"
import script from "./in-hub.vue?vue&type=script&lang=ts"
export * from "./in-hub.vue?vue&type=script&lang=ts"

import "./in-hub.vue?vue&type=style&index=0&id=06feba76&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__